import React from 'react';

interface ImageUploaderProps {
  label: string;
  value?: string;
  onChange: (value: string) => void;
  multiple?: boolean;
  language: 'ar' | 'en';
}

const ImageUploader: React.FC<ImageUploaderProps> = ({
  label,
  value,
  onChange,
  multiple = false,
  language
}) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target?.result) {
          onChange(e.target.result as string);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <div className="flex items-center space-x-4 rtl:space-x-reverse">
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          multiple={multiple}
          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
        />
        {value && (
          <img 
            src={value} 
            alt="Preview" 
            className="w-16 h-16 object-cover rounded border"
          />
        )}
      </div>
    </div>
  );
};

export default ImageUploader; 